<section>
  <div class="flex header">
    @if (props?.label) {
      <legend>{{ props.label }}</legend>
    }
  </div>
  @if (props?.description) {
    <p>{{ props.description }}</p>
  }
  <div class="repeated-fields">
    @for (child of field.fieldGroup; track i; let i = $index) {
      <div class="flex gap-1">
        <formly-field [field]="child"></formly-field>
        @if (field.fieldGroup.length > minItems && formControl.enabled) {
          <div>
            <button mat-icon-button (click)="remove(i)"><mat-icon>remove</mat-icon></button>
          </div>
        }
      </div>
    }
    @if (formControl.enabled) {
      @if (field.fieldGroup.length < maxItems) {
        @if (props?.addText) {
          <button
            id="add-button"
            mat-button
            color="accent"
            (click)="addWithProperIds()"
            [disabled]="isAddDisabled()"
          >
            {{ addText }}
          </button>
        } @else {
          <button mat-icon-button (click)="addWithProperIds()" [disabled]="isAddDisabled()">
            <mat-icon>add</mat-icon>
          </button>
        }
      } @else {
        <p class="max-items-reached">Max number of items reached.</p>
      }
    }
  </div>
</section>
